// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"d50c51aa","432":"c47fac79","712":"c47fac79","976":"811e5232"}[chunkId] + ".chunk.css";
};